import React from "react";
import _SmsDashboard from "../../components/dashboard/Sms";
const SmsDashboard = () => {
  return (
    <>
      <h2>SMS Dashboard</h2>

      <_SmsDashboard />
    </>
  );
};

export default SmsDashboard;
